import { Dialog, DialogContent, DialogActions, Button } from '@mui/material';
import { Snackbar } from '@mui/material';
import CustomSnackbar from '../../../Components/CustomSnackbar';
import React, { useState, useEffect, useRef } from 'react';
import { loadingKtvAmplifierDataComponent, loadingReserveDataComponent } from '../../../LoadingData/LoadingDataComponents';
import { UpdateAmplifierModel, UpdateReserve, UpdateReserveDescription, UpdateReserveModel } from '../../../UpdateData/UpdateCommunications';
import { DELETE_AMPLIFIER_ID_API_URL, DELETE_RESERVE_ID_API_URL } from '../../../OpticApiConfig';
import { UpdateAmplifierActivity } from '../../../UpdateData/UpdateStatusComponent';


const ReserveNodeCantonEditingDialog = ({ open, onClose, content, cantonRefresh}) => {

  const { showSnackbar, snackbarOpen, handleCloseSnackbar, snackbarMessage, snackbarClass } = CustomSnackbar();
  const [reserveData, setReserveData] = useState([]);
  const [reserveId, setReserveId] = useState("");
  const [commentReserve, setCommentReserve] = useState();
  const commentTextAreaRefReserve = useRef(null);
  const [statusChange, setStatusChange] = useState(false);
  
  
  const token = localStorage.getItem('token');

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [reserveData] = await Promise.all([
          loadingReserveDataComponent(),
        ]);
        setReserveData(reserveData);
      } catch (error) {
        // console.error("Error in fetchData:", error);
      }
    };
    fetchData();
  }, []);

  
  useEffect(() => {
    setCommentReserve(content?.reserveNodeDescription || "");
}, [content]);

  const handleCloseDialogs = () => {
    cantonRefresh();
    onClose();
  };


   const deleteReserve = async () => {
  
          if (!token) {
              showSnackbar('Ошибка! Токен не найден', 'snackbarWarning');
              return;
          }

          try {
              let apiReserve = `${DELETE_RESERVE_ID_API_URL}?reserveId=${content.id}`;

              const response = await fetch(apiReserve, { 
                  method: 'DELETE',
                  headers: {
                      'Content-Type': 'application/json',
                      'Authorization': `Bearer ${token}` 
                  }
              });
  
              if (response.ok) {
                  showSnackbar('Компонент успешно удален', 'snackbarWarning');
                  setReserveData([]);
                  setReserveId("");
                  cantonRefresh();
                  handleCloseDialogs();
              } else {
                  showSnackbar('Ошибка удаления!', 'snackbarWarning');
              }
          } catch (error) {
              showSnackbar('Произошла ошибка!', 'snackbarWarning');
          }  
      };

  const handleChangeReserveSelect = (event) => {
    const selectedReserve = event.target.value;
    if (selectedReserve === "") {
      setReserveId("");
    } else {
      const selectedReserve2 = reserveData.find(reserve => 
        `${reserve.id}` === selectedReserve
      );
      if (selectedReserve2) {
        setReserveId(selectedReserve2.id);
      }
    }
  };

  const updateModel = () => {
  
    if (reserveId === "") {
      showSnackbar('Нет нужды в записи, резерв без изменений!', 'snackbarOk');
    } else {
      UpdateReserveModel(content.id, reserveId, showSnackbar, cantonRefresh );
    } 
  };

 const handleCommentChangeReserve = (event) => {
    setCommentReserve(event.target.value);
  }

     const updateDescriptionReserve = () => {  
           UpdateReserveDescription(content.id, commentReserve, showSnackbar);
       };

 const handleDescriptionChange = (event) => {
        const newText = event.target.value;
        setCommentReserve(newText);
    
        if (newText !== content.comment) {
            setStatusChange(true);
        } else {
            setStatusChange(false);
        }
     };

  

 

    return (
  
    <Dialog open={open} className="dialogStyle">
    
      <DialogContent>
     
      <img src='./battery.png' width='30' height='30' style={{ marginRight: "5px" }} />
       
      <label style={{ color: '#dfab01', fontSize: '20px', fontFamily:'unset'}}>Редактирование резерва</label>
      <hr className='horizontalLineDialog'/>
      <label style={{ color: '#292929', fontWeight: 'bold'}}>ID: <span style={{ color: '#bebebe' }}>{content.id}</span></label>
      <br/>
      
      <hr className="horizontalLineDialog2" style={{marginTop: "10px"}}/> 
      <label style={{ color: '#292929', fontWeight: 'bold'}}>Резерв: </label>

      <select
            className="selectStyleDrawer"
            style={{
              marginBottom: "5px",
              marginTop: "10px",
              marginInlineEnd: "10px"
            }}
            onChange={(event) => {
          handleChangeReserveSelect(event);
        }} >
          
            <option value="">{content.isUps==0
                  ? `⚡ ${content.upsModel} | 🔋 ${content.batteryModel}`
                  : `⚡ ${content.upsModel}`}
              </option>

            {reserveData.map((reserve) => (
              <option key={reserve.id} value={reserve.id}>
                {reserve.isUps == 0
                  ? `⚡ ${reserve.upsModel} | 🔋 ${reserve.batteryModel}`
                  : `⚡ ${reserve.upsModel}`}
              </option>
            ))}
          </select>
      <button onClick={updateModel} class='buttonIsSaveDialog2'>Сохранить</button>
      <hr className="horizontalLineDialog2" style={{marginTop: "10px"}}/>
      <label style={{ color: '#292929', fontWeight: 'bold'}}>Описание: </label>
      <div >
      
 
          <textarea
           className='areaDescriptionDrawer'
           placeholder="Комментарий"
           style={{marginInlineEnd: "10px"}}
           rows={3}
           cols={44}
           value={commentReserve}
          
           onChange={handleCommentChangeReserve}
         />
         
       </div>
       <button onClick={updateDescriptionReserve} className='buttonIsSaveDialog2'>Сохранить</button>
        <hr className="horizontalLineDialog2" style={{marginTop: "40px"}}/>   
      <button onClick={deleteReserve} class='buttonIsDeleteModal2' style={{marginLeft:"0px"}}>Удалить</button>

      {/* <hr className='horizontalLineDialog'/>
      <button  class='buttonIsCoupFobDialog' onClick={openModalConnectionComponents}> Закрепить фоб</button> */}
      

      </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialogs} class='buttonIsHideDrawer23'>
            Закрыть
          </Button>
        </DialogActions>


       {/* Snackbar */}
       <Snackbar
         anchorOrigin={{
         vertical: 'bottom',
         horizontal: 'left',
         }}
         open={snackbarOpen}
         autoHideDuration={3000}
         onClose={handleCloseSnackbar}
         message={snackbarMessage}
         ContentProps={{
          style: {
            color: snackbarClass === 'snackbarOk' ? '#ffda62' : '#202020'
          }
        }}
      />

      
    </Dialog>
  );
}

export default ReserveNodeCantonEditingDialog;